import Vue from 'vue'
import 'chartist/dist/chartist.min.css'
import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.min'
import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.css'
import 'chartist-plugin-axistitle/dist/chartist-plugin-axistitle.min'

Vue.use(require('vue-chartist'))
